import { toast } from 'vue-sonner'

const ERROR_DURATION = 5000

export interface UseToast {
  show: (message: string) => void
  success: (message: string) => void
  error: (message: string | Error | unknown) => void
  warning: (message: string) => void
  info: (message: string) => void
}

export function useToast(): UseToast {
  function show(message: string): void {
    toast(message)
  }

  function success(message: string): void {
    toast.success(message)
  }

  function error(message: string | Error | unknown): void {
    const options = { duration: ERROR_DURATION }
    if (message instanceof Error) {
      toast.error(message.message, options)
    } else if (typeof message === 'string') {
      toast.error(message, options)
    } else {
      toast.error('An error occurred', options)
    }
  }

  function warning(message: string): void {
    toast.warning(message)
  }

  function info(message: string): void {
    toast.info(message)
  }

  return {
    show,
    success,
    error,
    warning,
    info,
  }
}
